import type { AssetPosition } from "kubb";
import type { DeviceAssetOut } from "kubb";
import { isEmpty } from "lodash-es";
import type React from "react";
import { Heading } from "../../../components/Theme/heading";
import DisplayIfUserType from "../../../components/utils/DisplayIfUserType/DisplayIfUserType";
import VirtualAssetCreateForm from "./virtual_assets/VirtualAssetCreateForm";
import VirtualAssetSummaryList from "./virtual_assets/VirtualAssetSummaryList";

const VirtualAssetTab = (props: {
  asset: DeviceAssetOut;
  assetPosition: AssetPosition;
}): React.ReactElement => {
  const { asset, assetPosition } = props;
  return (
    <>
      {!isEmpty(assetPosition.child_asset_positions) && (
        <>
          <Heading>Current Virtual Assets</Heading>
          <VirtualAssetSummaryList parentAssetPosition={assetPosition} />
        </>
      )}
      <DisplayIfUserType userTypes={"admin"}>
        <Heading>Create New Virtual Asset</Heading>
        <VirtualAssetCreateForm
          parentAsset={asset}
          parentAssetPosition={assetPosition}
        />
      </DisplayIfUserType>
    </>
  );
};

export default VirtualAssetTab;
